var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuardar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.9 32.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.98,28.25h-12.54c.19-.11.37-.23.52-.4l9.06-10.04c.54-.6.68-1.46.35-2.19-.33-.74-1.06-1.21-1.86-1.21h-6.27V2.8c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8v11.61h-6.27c-.8,0-1.53.47-1.86,1.21-.33.74-.19,1.59.35,2.19l9.06,10.04c.15.16.33.29.52.4H1.92c-1.06,0-1.92.86-1.92,1.92s.86,1.92,1.92,1.92h27.07c1.06,0,1.92-.86,1.92-1.92s-.86-1.92-1.92-1.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardar);
export default __webpack_public_path__ + "static/media/GUARDAR.6430fc996e101356a51735002b392294.svg";
export { ForwardRef as ReactComponent };